import { render, staticRenderFns } from "./merchant_visitlog.vue?vue&type=template&id=047df543&scoped=true"
import script from "./merchant_visitlog.vue?vue&type=script&lang=js"
export * from "./merchant_visitlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047df543",
  null
  
)

export default component.exports